module.exports = __webpack_public_path__ + "img/FR15449.1c680986.png";